import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=0d2ce7d0&scoped=true&"
import script from "./AppTab.vue?vue&type=script&lang=ts&"
export * from "./AppTab.vue?vue&type=script&lang=ts&"
import style0 from "./AppTab.vue?vue&type=style&index=0&id=0d2ce7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ce7d0",
  null
  
)

export default component.exports